module.exports = __webpack_public_path__ + "static/line1_4-0efea488095e389d38bc66815e122e71.jpg";